module.exports = __webpack_public_path__ + "img/footer-logo-element_large.27c65820.png";